import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {Item} from "../../../shared/models/item";
import {Category} from "../../../shared/models/category";

@Component({
  selector: 'app-category-details-popup',
  templateUrl: './category-details-popup.component.html',
  styleUrl: './category-details-popup.component.scss'
})
export class CategoryDetailsPopupComponent implements OnInit {

  category: Category;
  categoryForm: FormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<CategoryDetailsPopupComponent>) {
    this.category = data.category;
    this.categoryForm = this.formBuilder.group({
      identifier: [{value: this.category.identifier, disabled: !data.new}],
      text: [this.category.text, Validators.required],
      sortId: [this.category.sortId, Validators.required],
      showOnFrontend: [this.category.showOnFrontend, Validators.required],
      allowComment: [this.category.allowComment, Validators.required],
    });
  }

  ngOnInit() {
  }

  onSubmit() {
    if (this.categoryForm.valid) {
      const editedCategory: Category = this.categoryForm.value;
      this.dialogRef.close(editedCategory);
    }
  }

}
